export default {
  teamInfoTitle: 'Company Management',
  createTeamLabel: 'Create your company to manage your locations and positions with other users!',
  createTeamBtn: 'Create Company',
  editTeamLabel: 'Edit Company Name',
  addTeamBtn: 'Invite New Member',
  teamSearchPlaceholder: 'Search members',
  accountInviteCheck: {
    teamInvitationSuccess: "You've successfully joined this team via invite!",
    teamInvitationFailed: 'An error occurred when attempting to join this team.',
    warningTitle: 'Warning: Permanent Account Transfer',
    warningBody: "You've been invited to join an organization's account.",
    warningBodyExtra:
      'Please be aware that accepting this invitation will transfer your profile to this new organization. All data associated with your current organization, including candidates, job positions, and messages, will no longer be accessible to you. This action cannot be undone.',
    toProceedText: 'To proceed with transferring your profile to this organization, click',
    joinCompany: 'Join Organization',
    cancel: 'Cancel',
  },
  teamInfoTableHeader: {
    name: 'Name',
    status: 'Status',
    phoneNumber: 'Phone number',
    action: 'Options',
  },
  teamInviteTableHeader: {
    email: 'Email',
    status: 'Status',
    action: 'Options',
  },
  accountInviteInfo: 'Pending Invitations',
  confirmationMessage: {
    promote: `Are you sure you want to give administrative rights to {{teamMemberName}}.`,
    demote: `Are you sure you want to revoke {{teamMemberName}}'s administrative rights?`,
    delete: `Are you sure you want to remove {{teamMemberName}} from the company?`,
    cancel: `Are you sure you want to cancel the invitation sent to {{inviteEmail}}?`,
    reInvite: `Are you sure you want to resend an invitation to {{inviteEmail}}?`,
    restrict: `Are you sure you want to restrict {{teamMemberName}} from position?`,
    unRestrict: `Are you sure you want to unrestrict {{teamMemberName}} from position?`,
  },
  successMessage: {
    promote: `{{teamMemberName}} has been successfully given administrative rights.`,
    demote: `{{teamMemberName}} 's administrative rights have successfully been revoked..`,
    delete: `{{teamMemberName}} has been successfully removed from the Company.`,
    cancel: `The email invitation for {{inviteEmail}} has been canceled successfully.`,
    reInvite: `The email invitation for {{inviteEmail}} has been re-sent successfully.`,
    restrict: `{{teamMemberName}} is successfully restricted from position.`,
    unRestrict: `{{teamMemberName}} is successfully unrestricted from position.`,
  },
  createTeamModal: {
    createLabel: 'Name your Company',
    editLabel: 'Edit Your Company Name',
    cancelBtn: 'Cancel',
    saveBtn: 'Save',
    updateBtn: 'Update',
    successMessage: {
      create: 'Company name saved successfully',
      update: 'Company name updated successfully.',
    },
    validationMessage: {
      name: 'Company name is required',
      empty: 'Email is required',
      validation: 'Must be a valid email address',
    },
  },
  inviteTeamModal: {
    inviteLabel: 'Invite New  Member',
    inviteEmailPlaceholder: 'Email',
    cancelBtn: 'Cancel',
    saveBtn: 'Send',
    validationMessage: {
      empty: 'Email is required',
      name: `Name is required`,
      validation: 'Must be a valid email address',
    },
  },
  noData: 'No data found.',
  noPendingInvitation: 'No pending invitations found.',
  cancelInvite: 'Cancel Invitation',
  resend: 'Resend',
  confirmBtn: 'Confirm',
  cancelBtn: 'Cancel',
  admin: 'Admin',
  superAdmin: 'Super Admin',
  restrictedRecruiter: 'Restricted Recruiter',
  active: 'Active',
  pending: 'Pending',
  expired: 'Expired',
  menuItems: {
    allowPermissions: 'Edit Permissions',
    removeAccount: 'Remove From Account',
    revokeAdmin: 'Revoke Admin Status',
    makeAdmin: 'Make Admin',
    restrictUserPosition: 'Restrict Positions',
    unRestrictUserPosition: 'Unrestrict Positions',
  },
  hasAdminAccess: 'Has Admin Permissions',
  hasRequestAccess: 'Has Request/Resubmit Permissions',
  hasReviewAccess: 'Has Review Permissions',
  permissionModal: {
    title: 'Permissions',
    subTitle: 'Manage permissions for users to access and request forms from candidates.',
    cancelBtn: 'Cancel',
    confirmBtn: 'Confirm',
    successMessage: 'Permissions updated successfully',
    backgroundCheck: {
      heading: 'Background Check',
      admin: {
        title: 'Admin',
        description: 'Can configure the Background Check process.',
      },
      review: {
        title: 'Review',
        description: 'Can view Background Check results only. Cannot take any actions.',
      },
      request: {
        title: 'Request / Resubmit',
        description: 'Can initiate Background Check requests and take actions (approve, decline, request resubmission).',
      },
    },
    hrForm: {
      heading: 'HR Form',
      admin: {
        title: 'Admin',
        description: 'Can configure HR Form process, including creating, editing, and copying HR Form templates.',
      },
      review: {
        title: 'Review',
        description: 'Can only view HR Form submissions. No editing or approval rights.',
      },
      request: {
        title: 'Request / Resubmit',
        description: 'Can start HR Form requests, review and take actions (approve, decline, request resubmission).',
      },
    },
    i9Form: {
      heading: 'I-9 Forms',
      admin: {
        title: 'Admin',
        description: 'Can configure the I-9 Verification process.',
      },
      review: {
        title: 'Review',
        description: 'Can access and review I-9 submissions. No action permissions.',
      },
      request: {
        title: 'Request / Resubmit',
        description: 'Can start I-9 Verification requests and take actions (approve, decline, request resubmission).',
      },
    },
  },
};
